import { render } from "./OrderShow.vue?vue&type=template&id=08289870&scoped=true"
import script from "./OrderShow.vue?vue&type=script&lang=js"
export * from "./OrderShow.vue?vue&type=script&lang=js"

import "./OrderShow.vue?vue&type=style&index=0&id=08289870&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08289870"]])

export default __exports__